import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Palmtree } from 'lucide-react';

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const hideFooter = ['/login', '/register', '/forgot-password', '/reset-password'].includes(location.pathname);
  if (hideFooter) return null;

  return (
    <footer className="border-t border-stone-200 bg-white/50 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 py-8 sm:py-10">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div className="flex items-center gap-2">
            <Palmtree className="w-5 h-5 text-[#005F73]" strokeWidth={1.5} />
            <span className="text-sm font-semibold text-[#005F73]">GwadImmo Invest</span>
          </div>

          <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-stone-500">
            <button onClick={() => navigate('/legal')} className="hover:text-[#005F73] transition-colors" data-testid="footer-legal">
              Mentions légales
            </button>
            <button onClick={() => navigate('/terms')} className="hover:text-[#005F73] transition-colors" data-testid="footer-terms">
              CGV
            </button>
            <button onClick={() => navigate('/privacy')} className="hover:text-[#005F73] transition-colors" data-testid="footer-privacy">
              Confidentialité
            </button>
            <a href="mailto:gwadimmo.invest@gmail.com" className="hover:text-[#005F73] transition-colors" data-testid="footer-contact">
              Contact
            </a>
          </nav>
        </div>

        <div className="mt-6 pt-6 border-t border-stone-100 text-center">
          <p className="text-xs text-stone-400">
            &copy; {new Date().getFullYear()} GwadImmo Invest. Tous droits réservés. Les calculs sont donnés à titre indicatif.
          </p>
        </div>
      </div>
    </footer>
  );
}
